import { render, staticRenderFns } from "./ContractorsWorksTab.vue?vue&type=template&id=b4b8d80c&"
import script from "./ContractorsWorksTab.vue?vue&type=script&lang=js&"
export * from "./ContractorsWorksTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports